import { createSlice } from '@reduxjs/toolkit';
import { resetApplication } from '../application/slice';
import chartsState from './state';
const chartsSlice = createSlice({
    extraReducers: builder => {
        builder.addCase(resetApplication, () => chartsState);
    },
    initialState: chartsState,
    name: 'charts',
    reducers: {
        errorReceiveAirflowChart: state => {
            state.airflowChart = undefined;
            state.requestingAirflowChart = false;
        },
        errorReceiveEgressInterfaceChart: state => {
            state.egressInterfaceChart = undefined;
            state.requestingEgressInterfaceChart = false;
        },
        errorReceiveEgressLockerCharts: state => {
            state.egressLockerCharts = undefined;
            state.requestingEgressLockerCharts = false;
        },
        errorReceiveEgressSiteCharts: state => {
            state.egressSiteCharts = undefined;
            state.requestingEgressSiteCharts = false;
        },
        errorReceiveHumidityChart: state => {
            state.humidityChart = undefined;
            state.requestingHumidityChart = false;
        },
        errorReceiveIngressInterfaceChart: state => {
            state.ingressInterfaceChart = undefined;
            state.requestingIngressInterfaceChart = false;
        },
        errorReceiveIngressLockerCharts: state => {
            state.ingressLockerCharts = undefined;
            state.requestingIngressLockerCharts = false;
        },
        errorReceiveIngressSiteCharts: state => {
            state.ingressSiteCharts = undefined;
            state.requestingIngressSiteCharts = false;
        },
        errorReceiveLockerPowerConsumptionChart: state => {
            state.lockerPowerConsumptionChart = undefined;
            state.requestingLockerPowerConsumptionChart = false;
        },
        errorReceivePowerConsumptionChart: state => {
            state.powerConsumptionChart = undefined;
            state.requestingPowerConsumptionChart = false;
        },
        errorReceivePressureChart: state => {
            state.pressureChart = undefined;
            state.requestingPressureChart = false;
        },
        errorReceiveRackPressureChart: state => {
            state.rackPressureChart = undefined;
            state.requestingRackPressureChart = false;
        },
        errorReceiveRackTemperatureChart: state => {
            state.rackTemperatureChart = undefined;
            state.requestingRackTemperatureChart = false;
        },
        errorReceiveTemperatureChart: state => {
            state.temperatureChart = undefined;
            state.requestingTemperatureChart = false;
        },
        failedReceiveAirflowChart: state => {
            state.airflowChart = undefined;
            state.requestingAirflowChart = false;
        },
        failedReceiveEgressInterfaceChart: state => {
            state.egressInterfaceChart = undefined;
            state.requestingEgressInterfaceChart = false;
        },
        failedReceiveEgressLockerCharts: state => {
            state.egressLockerCharts = undefined;
            state.requestingEgressLockerCharts = false;
        },
        failedReceiveEgressSiteCharts: state => {
            state.egressSiteCharts = undefined;
            state.requestingEgressSiteCharts = false;
        },
        failedReceiveHumidityChart: state => {
            state.humidityChart = undefined;
            state.requestingHumidityChart = false;
        },
        failedReceiveIngressInterfaceChart: state => {
            state.ingressInterfaceChart = undefined;
            state.requestingIngressInterfaceChart = false;
        },
        failedReceiveIngressLockerCharts: state => {
            state.ingressLockerCharts = undefined;
            state.requestingIngressLockerCharts = false;
        },
        failedReceiveIngressSiteCharts: state => {
            state.ingressSiteCharts = undefined;
            state.requestingIngressSiteCharts = false;
        },
        failedReceiveLockerPowerConsumptionChart: state => {
            state.lockerPowerConsumptionChart = undefined;
            state.requestingLockerPowerConsumptionChart = false;
        },
        failedReceivePowerConsumptionChart: state => {
            state.powerConsumptionChart = undefined;
            state.requestingPowerConsumptionChart = false;
        },
        failedReceivePressureChart: state => {
            state.pressureChart = undefined;
            state.requestingPressureChart = false;
        },
        failedReceiveRackPressureChart: state => {
            state.rackPressureChart = undefined;
            state.requestingRackPressureChart = false;
        },
        failedReceiveRackTemperatureChart: state => {
            state.rackTemperatureChart = undefined;
            state.requestingRackTemperatureChart = false;
        },
        failedReceiveTemperatureChart: state => {
            state.temperatureChart = undefined;
            state.requestingTemperatureChart = false;
        },
        receiveAirflowChart: {
            prepare: airflowChart => {
                return {
                    payload: {
                        airflowChart
                    }
                };
            },
            reducer: (state, action) => {
                const { airflowChart } = action.payload;
                state.airflowChart = airflowChart;
                state.requestingAirflowChart = false;
            }
        },
        receiveEgressInterfaceChart: {
            prepare: egressInterfaceChart => {
                return {
                    payload: {
                        egressInterfaceChart
                    }
                };
            },
            reducer: (state, action) => {
                const { egressInterfaceChart } = action.payload;
                state.egressInterfaceChart = egressInterfaceChart;
                state.requestingEgressInterfaceChart = false;
            }
        },
        receiveEgressLockerCharts: {
            prepare: egressLockerCharts => {
                return {
                    payload: {
                        egressLockerCharts
                    }
                };
            },
            reducer: (state, action) => {
                const { egressLockerCharts } = action.payload;
                state.egressLockerCharts = egressLockerCharts;
                state.requestingEgressLockerCharts = false;
            }
        },
        receiveEgressSiteCharts: {
            prepare: egressSiteCharts => {
                return {
                    payload: {
                        egressSiteCharts
                    }
                };
            },
            reducer: (state, action) => {
                const { egressSiteCharts } = action.payload;
                state.egressSiteCharts = egressSiteCharts;
                state.requestingEgressSiteCharts = false;
            }
        },
        receiveHumidityChart: {
            prepare: humidityChart => {
                return {
                    payload: {
                        humidityChart
                    }
                };
            },
            reducer: (state, action) => {
                const { humidityChart } = action.payload;
                state.humidityChart = humidityChart;
                state.requestingHumidityChart = false;
            }
        },
        receiveIngressInterfaceChart: {
            prepare: ingressInterfaceChart => {
                return {
                    payload: {
                        ingressInterfaceChart
                    }
                };
            },
            reducer: (state, action) => {
                const { ingressInterfaceChart } = action.payload;
                state.ingressInterfaceChart = ingressInterfaceChart;
                state.requestingIngressInterfaceChart = false;
            }
        },
        receiveIngressLockerCharts: {
            prepare: ingressLockerCharts => {
                return {
                    payload: {
                        ingressLockerCharts
                    }
                };
            },
            reducer: (state, action) => {
                const { ingressLockerCharts } = action.payload;
                state.ingressLockerCharts = ingressLockerCharts;
                state.requestingIngressLockerCharts = false;
            }
        },
        receiveIngressSiteCharts: {
            prepare: ingressSiteCharts => {
                return {
                    payload: {
                        ingressSiteCharts
                    }
                };
            },
            reducer: (state, action) => {
                const { ingressSiteCharts } = action.payload;
                state.ingressSiteCharts = ingressSiteCharts;
                state.requestingIngressSiteCharts = false;
            }
        },
        receiveLockerPowerConsumptionChart: {
            prepare: lockerPowerConsumptionChart => {
                return {
                    payload: {
                        lockerPowerConsumptionChart
                    }
                };
            },
            reducer: (state, action) => {
                const { lockerPowerConsumptionChart } = action.payload;
                state.lockerPowerConsumptionChart = lockerPowerConsumptionChart;
                state.requestingLockerPowerConsumptionChart = false;
            }
        },
        receivePowerConsumptionChart: {
            prepare: powerConsumptionChart => {
                return {
                    payload: {
                        powerConsumptionChart
                    }
                };
            },
            reducer: (state, action) => {
                const { powerConsumptionChart } = action.payload;
                state.powerConsumptionChart = powerConsumptionChart;
                state.requestingPowerConsumptionChart = false;
            }
        },
        receivePressureChart: {
            prepare: pressureChart => {
                return {
                    payload: {
                        pressureChart
                    }
                };
            },
            reducer: (state, action) => {
                const { pressureChart } = action.payload;
                state.pressureChart = pressureChart;
                state.requestingPressureChart = false;
            }
        },
        receiveRackPressureChart: {
            prepare: rackPressureChart => {
                return {
                    payload: {
                        rackPressureChart
                    }
                };
            },
            reducer: (state, action) => {
                const { rackPressureChart } = action.payload;
                state.rackPressureChart = rackPressureChart;
                state.requestingRackPressureChart = false;
            }
        },
        receiveRackTemperatureChart: {
            prepare: rackTemperatureChart => {
                return {
                    payload: {
                        rackTemperatureChart
                    }
                };
            },
            reducer: (state, action) => {
                const { rackTemperatureChart } = action.payload;
                state.rackTemperatureChart = rackTemperatureChart;
                state.requestingRackTemperatureChart = false;
            }
        },
        receiveTemperatureChart: {
            prepare: temperatureChart => {
                return {
                    payload: {
                        temperatureChart
                    }
                };
            },
            reducer: (state, action) => {
                const { temperatureChart } = action.payload;
                state.temperatureChart = temperatureChart;
                state.requestingTemperatureChart = false;
            }
        },
        requestAirflowChart: {
            prepare: chartOptions => {
                return {
                    payload: {
                        chartOptions
                    }
                };
            },
            reducer: state => {
                state.requestingAirflowChart = true;
            }
        },
        requestEgressInterfaceChart: {
            prepare: chartOptions => {
                return {
                    payload: {
                        chartOptions
                    }
                };
            },
            reducer: state => {
                state.requestingEgressInterfaceChart = true;
            }
        },
        requestEgressLockerCharts: {
            prepare: chartOptions => {
                return {
                    payload: {
                        chartOptions
                    }
                };
            },
            reducer: state => {
                state.requestingEgressLockerCharts = true;
            }
        },
        requestEgressSiteCharts: {
            prepare: chartOptions => {
                return {
                    payload: {
                        chartOptions
                    }
                };
            },
            reducer: state => {
                state.requestingEgressSiteCharts = true;
            }
        },
        requestHumidityChart: {
            prepare: chartOptions => {
                return {
                    payload: {
                        chartOptions
                    }
                };
            },
            reducer: state => {
                state.requestingHumidityChart = true;
            }
        },
        requestIngressInterfaceChart: {
            prepare: chartOptions => {
                return {
                    payload: {
                        chartOptions
                    }
                };
            },
            reducer: state => {
                state.requestingIngressInterfaceChart = true;
            }
        },
        requestIngressLockerCharts: {
            prepare: chartOptions => {
                return {
                    payload: {
                        chartOptions
                    }
                };
            },
            reducer: state => {
                state.requestingIngressLockerCharts = true;
            }
        },
        requestIngressSiteCharts: {
            prepare: chartOptions => {
                return {
                    payload: {
                        chartOptions
                    }
                };
            },
            reducer: state => {
                state.requestingIngressSiteCharts = true;
            }
        },
        requestLockerPowerConsumptionChart: {
            prepare: chartOptions => {
                return {
                    payload: {
                        chartOptions
                    }
                };
            },
            reducer: state => {
                state.requestingLockerPowerConsumptionChart = true;
            }
        },
        requestPowerConsumptionChart: {
            prepare: chartOptions => {
                return {
                    payload: {
                        chartOptions
                    }
                };
            },
            reducer: state => {
                state.requestingPowerConsumptionChart = true;
            }
        },
        requestPressureChart: {
            prepare: chartOptions => {
                return {
                    payload: {
                        chartOptions
                    }
                };
            },
            reducer: state => {
                state.requestingPressureChart = true;
            }
        },
        requestRackPressureChart: {
            prepare: chartOptions => {
                return {
                    payload: {
                        chartOptions
                    }
                };
            },
            reducer: state => {
                state.requestingRackPressureChart = true;
            }
        },
        requestRackTemperatureChart: {
            prepare: chartOptions => {
                return {
                    payload: {
                        chartOptions
                    }
                };
            },
            reducer: state => {
                state.requestingRackTemperatureChart = true;
            }
        },
        requestTemperatureChart: {
            prepare: chartOptions => {
                return {
                    payload: {
                        chartOptions
                    }
                };
            },
            reducer: state => {
                state.requestingTemperatureChart = true;
            }
        },
        resetCharts: () => chartsState,
        resetEgressInterfaceChart: state => {
            state.egressInterfaceChart = undefined;
            state.requestingEgressInterfaceChart = false;
        },
        resetIngressInterfaceChart: state => {
            state.ingressInterfaceChart = undefined;
            state.requestingIngressInterfaceChart = false;
        },
        resetRackPressureChart: state => {
            state.rackPressureChart = undefined;
            state.requestingRackPressureChart = false;
        },
        resetRackTemperatureChart: state => {
            state.rackTemperatureChart = undefined;
            state.requestingRackTemperatureChart = false;
        }
    }
});
export const { errorReceiveAirflowChart, errorReceiveEgressInterfaceChart, errorReceiveEgressLockerCharts, errorReceiveEgressSiteCharts, errorReceiveHumidityChart, errorReceiveIngressInterfaceChart, errorReceiveIngressLockerCharts, errorReceiveIngressSiteCharts, errorReceiveLockerPowerConsumptionChart, errorReceivePowerConsumptionChart, errorReceivePressureChart, errorReceiveRackPressureChart, errorReceiveRackTemperatureChart, errorReceiveTemperatureChart, failedReceiveAirflowChart, failedReceiveEgressInterfaceChart, failedReceiveEgressLockerCharts, failedReceiveEgressSiteCharts, failedReceiveHumidityChart, failedReceiveIngressInterfaceChart, failedReceiveIngressLockerCharts, failedReceiveIngressSiteCharts, failedReceiveLockerPowerConsumptionChart, failedReceivePowerConsumptionChart, failedReceivePressureChart, failedReceiveRackPressureChart, failedReceiveRackTemperatureChart, failedReceiveTemperatureChart, receiveAirflowChart, receiveEgressInterfaceChart, receiveEgressLockerCharts, receiveEgressSiteCharts, receiveHumidityChart, receiveIngressInterfaceChart, receiveIngressLockerCharts, receiveIngressSiteCharts, receiveLockerPowerConsumptionChart, receivePowerConsumptionChart, receivePressureChart, receiveRackPressureChart, receiveRackTemperatureChart, receiveTemperatureChart, requestAirflowChart, requestEgressInterfaceChart, requestEgressLockerCharts, requestEgressSiteCharts, requestHumidityChart, requestIngressInterfaceChart, requestIngressLockerCharts, requestIngressSiteCharts, requestLockerPowerConsumptionChart, requestPowerConsumptionChart, requestPressureChart, requestRackPressureChart, requestRackTemperatureChart, requestTemperatureChart, resetCharts, resetEgressInterfaceChart, resetIngressInterfaceChart, resetRackPressureChart, resetRackTemperatureChart } = chartsSlice.actions;
export default chartsSlice.reducer;
